export const Color = {
  Primary: '#f69f30',
  Secondary: '#ffedd5',
  white: '#fff',
  lightGray: '#c0c0c0',
  darkGray: '#484848',
};
